<template>
  <div>
    <v-btn
      v-for="(button, i) in buttons"
      :key="i"
      @click="$emit('input', button.type)"
      :outlined="active !== button.type"
      :color="active === button.type ? colorActive : colorInactive"
      :small="!!small"
      :medium="!!medium"
      :large="!!large"
      tile
      depressed
      class="text-capitalize"
      style="font-weight: 400; letter-spacing: 0"
      >{{ button.name
      }}<v-icon v-if="button.icon" small right>{{ button.icon }}</v-icon></v-btn
    >
  </div>
</template>

<script>
export default {
  name: "ToggleButtons",
  props: {
    buttons: {
      type: Array,
      default: () => []
    },
    active: {
      type: String,
      default: undefined
    },
    small: {
      type: Boolean,
      default: false
    },
    medium: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    colorActive: {
      type: String,
      default: "primary"
    },
    colorInactive: {
      type: String,
      default: "#9c9c9c"
    }
  }
};
</script>

<style scoped></style>
